module.exports = __webpack_public_path__ + "static/media/SM-MT1-TRIAL.963bfc03.mp3";